import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@one-thd/sui-atomic-components';

interface InvalidItemsModalProps {
  title: string;
  body: React.JSX.Element;
  primaryButtonText: string;
  secondaryButtonText: string;
  onPrimaryClick: () => void;
  onSecondaryClick: () => void;
  onClose: () => void;
}

const InvalidItemsModal = ({
  title,
  body,
  primaryButtonText,
  secondaryButtonText,
  onPrimaryClick,
  onSecondaryClick,
  onClose,
}: InvalidItemsModalProps) => {
  return (
    <Modal open onClose={onClose} size="sm" data-testid="invalid-items-modal">
      <ModalHeader onClose={onClose}>{title}</ModalHeader>
      <ModalBody>{body}</ModalBody>
      <ModalFooter>
        <div className="sui-w-full sui-flex sui-flex-col sui-gap-[15px]">
          <Button
            variant="primary"
            onClick={onPrimaryClick}
            fullWidth
            data-testid="modal-action"
          >
            {primaryButtonText}
          </Button>
          <Button
            variant="secondary"
            onClick={onSecondaryClick}
            fullWidth
            data-testid="modal-action"
          >
            {secondaryButtonText}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default InvalidItemsModal;
